import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { ClassHandoverModel } from '../models/class-handover.model';
import { ResultModel } from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class ClassHandoverService  extends BaseService{

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<ClassHandoverModel[]>>(this.getApiUrl("instructors/handover"), formData);
  }

  create(parent: ClassHandoverModel) {

     return this.httpClient.post<ResultModel>(this.getApiUrl("instructors/handovercreate"), parent);
  }

}
